import { ComponentProps } from 'react';

// Design System
import { DayPicker } from 'jl-design-system/components/day-picker/DayPicker';

// Components
import DayPickerSelectedDay from '@components/day-picker-selected-day';

// Styles
import styles from './click-and-collect-day-picker-wrapper.scss';

type DayPickerSelectedDayMessageType = 'information' | 'error' | 'success' | 'warning' | 'info';
type DayPickerSelectedDayMessageRole = 'alert' | 'information';

type ClickAndCollectDayPickerWrapperProps = ComponentProps<typeof DayPicker> & {
  focusOnSelectedDayMessage?: boolean;
  selectedDayMessageBody?: string;
  selectedDayMessageClassName?: string;
  selectedDayMessageRole?: DayPickerSelectedDayMessageRole;
  selectedDayMessageTitle?: string;
  selectedDayMessageType?: DayPickerSelectedDayMessageType;
};

const ClickAndCollectDayPickerWrapper = ({
  selectedDayMessageBody,
  selectedDayMessageClassName,
  selectedDayMessageRole,
  selectedDayMessageTitle,
  selectedDayMessageType,
  focusOnSelectedDayMessage,
  selectedDay,
  ...dayPickerProps
}: ClickAndCollectDayPickerWrapperProps) => {
  return (
    <>
      <div className={styles.dayPickerContainer}>
        <DayPicker {...dayPickerProps} selectedDay={selectedDay} />
      </div>

      <div className={styles.selectedDayMessageContainer} data-testid="selected-day-message-container">
        <DayPickerSelectedDay
          focusOnSelectedDayMessage={focusOnSelectedDayMessage}
          selectedDay={selectedDay}
          selectedDayMessageBody={selectedDayMessageBody}
          selectedDayMessageClassName={selectedDayMessageClassName}
          selectedDayMessageRole={selectedDayMessageRole}
          selectedDayMessageTitle={selectedDayMessageTitle}
          selectedDayMessageType={selectedDayMessageType}
        />
      </div>
    </>
  );
};

export default ClickAndCollectDayPickerWrapper;
